const russianTimezones = [
  { value: 'UTC', offset: 0 },
  { value: 'Europe/Kaliningrad', offset: 2 },
  { value: 'Europe/Moscow', offset: 3 },
  { value: 'Europe/Samara', offset: 4 },
  { value: 'Asia/Yekaterinburg', offset: 5 },
  { value: 'Asia/Omsk', offset: 6 },
  { value: 'Asia/Novosibirsk', offset: 7 },
  { value: 'Asia/Krasnoyarsk', offset: 7 },
  { value: 'Asia/Irkutsk', offset: 8 },
  { value: 'Asia/Yakutsk', offset: 9 },
  { value: 'Asia/Vladivostok', offset: 10 },
  { value: 'Asia/Magadan', offset: 11 },
  { value: 'Asia/Kamchatka', offset: 12 },
];

const formatOffset = (offset: number) => (offset >= 0 ? `+${offset}` : `${offset}`);

export const defaultTimezone = 'UTC';
export const timezoneOptions = russianTimezones.map(({ value, offset }) => ({
  value,
  label: `[GMT${formatOffset(offset)}] ${value}`,
}));
